module.exports = "/assets/data/c157425c8a0d951f2e4688a88852a419-LS21.data.json";